module.exports = __webpack_public_path__ + "static/img/15.b96c24c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/15.png
// module id = 298Q
// module chunks = 0